import {Table, TableBody, TableCell, TableHead, TableRow} from '@material-ui/core';
import {WidgetCard, FeedbackDetail, PageTab} from 'components';
import {useState} from 'react';
import {cropAndEllipsis} from 'components/forms/locale/utils';
import {useGetAllFeedback} from 'hooks';
import InjectFrontendState from './InjectFrontendState';

const ViewFeedback = () => {
    const feedback = useGetAllFeedback();
    const isLoading = feedback?.isLoading;
    const error = feedback?.error;
    const [detailDrawerOpen, setDetailDrawerOpen] = useState(false);
    const [detailData, setDetailData] = useState({});

    const sortedData = feedback?.data?.sort((a, b) => {
        return a.datetime_submitted < b.datetime_submitted ? 1 : -1;
    });

    const toggleDrawer = () => {
        setDetailDrawerOpen(!detailDrawerOpen);
    };

    const openDetail = viewData => {
        setDetailDrawerOpen(true);
        setDetailData(viewData);
    };

    return (
        <PageTab isLoading={isLoading} error={error}>
            <InjectFrontendState />
            <WidgetCard
                title='User Feedback'
                hasData={feedback?.data?.length}
                allowOverflow
            >
                <Table width='100%' overflow='hidden'>
                    <TableHead>
                        <TableRow>
                            {['User Email', 'Date Submitted', 'Feedback Text'].map(
                                cell => {
                                    return <TableCell key={cell}>{cell}</TableCell>;
                                }
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sortedData?.map(row => {
                            return (
                                <TableRow
                                    key={row.id}
                                    onClick={() => openDetail(row)}
                                >
                                    <TableCell>{row.user_email}</TableCell>
                                    <TableCell>{row.datetime_submitted}</TableCell>
                                    <TableCell>
                                        {cropAndEllipsis(row.feedback_text, 250)}
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </WidgetCard>
            <FeedbackDetail
                data={detailData}
                isOpen={detailDrawerOpen}
                toggle={toggleDrawer}
                close={toggleDrawer}
            />
        </PageTab>
    );
};

export default ViewFeedback;
